import { saveAs } from 'file-saver'

export const openPDF = (file: Blob, fileName: string, cb?: () => void) => {
  // const isIOS = /iPad|iPhone|iPod/.test(navigator?.userAgent)
  // const blobURL = window.URL.createObjectURL(file)
  // if (isIOS) {
  //   window.open(blobURL, '_blank')
  // } else {
  //   const link = document.createElement('a')
  //   link.href = blobURL
  //   link.download = `${fileName}.pdf`
  //   document.body.appendChild(link)
  //   link.click()

  //   setTimeout(() => {
  //     document.body.removeChild(link)
  //     window.URL.revokeObjectURL(link.href)
  //   }, 0)
  // }
  saveAs(file, `${fileName}.pdf`)
  if (cb) {
    cb()
  }
}
const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const base64data = reader.result as string
      resolve(base64data.split(',')[1])
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

function sanitizePdfFileName(fileName: string): string {
  const trimmed = fileName?.trim() || 'documento'
  return trimmed.replaceAll(/[/\\?%*:|"<>]/g, '')
}

async function assertResponseIsPdfBlob(blob: Blob): Promise<void> {
  if (blob.size === 0) {
    throw new Error('El archivo PDF está vacío.')
  }
  const sampleSize = Math.min(256, blob.size)
  const sample = await blob.slice(0, sampleSize).text()
  const trimmed = sample.trimStart()
  if (
    trimmed.startsWith('<?xml') ||
    trimmed.startsWith('<Error') ||
    trimmed.startsWith('<')
  ) {
    throw new Error(
      'No se pudo descargar el PDF. La URL pudo haber expirado o el servidor devolvió un error.'
    )
  }
  if (!trimmed.startsWith('%PDF')) {
    throw new Error('La respuesta no es un PDF válido.')
  }
}

/**
 * Descarga el PDF inmediatamente vía fetch+blob para evitar abrir la URL en otra pestaña
 * (URLs firmadas que expiran suelen devolver XML de error al abrirlas después).
 */
export const openPDFFromUrl = async (
  url: string,
  fileName: string,
  cb?: () => void
): Promise<void> => {
  const response = await fetch(url, { method: 'GET' })
  if (!response.ok) {
    throw new Error(`No se pudo descargar el PDF (${response.status}).`)
  }
  const blob = await response.blob()
  await assertResponseIsPdfBlob(blob)
  const safeName = sanitizePdfFileName(fileName)
  saveAs(blob, `${safeName}.pdf`)
  if (cb) {
    cb()
  }
}

export const openPDFNew = async (
  file: Blob,
  fileName: string,
  cb?: () => void
) => {
  try {
    const base64 = await blobToBase64(file)
    const linkSource = `data:application/pdf;base64,${base64}`
    const link = document.createElement('a')
    link.href = linkSource
    link.download = `${fileName}.pdf`
    document.body.appendChild(link)
    link.click()

    setTimeout(() => {
      document.body.removeChild(link)
    }, 0)

    if (cb) {
      cb()
    }
  } catch (error) {
    console.error('Error al convertir el Blob a base64', error)
  }
}
